import client from "../apolloClient";
import { GET_SALON_SERVICES_GROUPED_BY_CATEGORY } from "../queries/salonService.queries";

export interface Category {
    id: string;
    category_name: string;
    }
    
export interface SalonService {
    id: string;
    description: string | null;
    price: number;
    duration: string;
    status: string;
    service: {
        id: string;
        service_name: string;
    };
}

export interface GroupedService {
    category: Category;
    services: SalonService[];
    }
    
export const getSalonServicesGroupedByCategory = async (salonId: string): Promise<GroupedService[]> => {
    try {
      console.log('🔍 Making GraphQL request to:', client.link);
      console.log('🔍 Query variables:', { salonId });
      
      const { data } = await client.query({
        query: GET_SALON_SERVICES_GROUPED_BY_CATEGORY,
        variables: { salonId },
        fetchPolicy: 'network-only',
      });
      
      console.log('✅ GraphQL response received:', data);
      return data.getSalonServicesGroupedByCategory;
    } catch (error: any) {
      console.error('❌ GraphQL Error:', error);
      console.error('❌ Error type:', typeof error);
      console.error('❌ Error message:', error?.message);
      console.error('❌ Network error:', error?.networkError);
      console.error('❌ GraphQL errors:', error?.graphQLErrors);
      throw error;
    }
  }